export class Onboarding {
  id: number | null;
  questionsAnswered: boolean;
  learnPromptShown: boolean;
  classicModeDialogShown: boolean;

  constructor(id: number | null, questionsAnswered: boolean, learnPromptShown: boolean, classicModeDialogShown: boolean) {
    this.id = id;
    this.questionsAnswered = questionsAnswered;
    this.learnPromptShown = learnPromptShown;
    this.classicModeDialogShown = classicModeDialogShown;
  }

  public static constructOnboarding(raw: any): Onboarding {
    return new Onboarding(
      raw.id,
      raw.questionsAnswered,
      raw.learnPromptShown,
      raw.classicModeDialogShown
    );
  }
}